import { useIntl } from 'react-intl';
import { IconLayoutGrid } from '@rossum/ui/icons/tabler';
import { Stack, SvgIcon, Typography } from '@rossum/ui/material';

export const EmptyExtensionsList = () => {
  const intl = useIntl();
  return (
    <Stack
      sx={{ pt: 15 }}
      spacing={4}
      alignItems="center"
      data-cy="extensions-empty-results"
    >
      <Typography color="other.muted">
        <SvgIcon fontSize="xLarge" color="inherit">
          <IconLayoutGrid />
        </SvgIcon>
      </Typography>
      <Typography variant="body1">
        {intl.formatMessage({
          id: 'containers.settings.extensions.noResults',
        })}
      </Typography>
    </Stack>
  );
};
